import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePCrmInvoiceCategory, PCrmInvoiceCategory } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<PCrmInvoiceCategory>
      useData={usePCrmInvoiceCategory}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
